import {
    FINANCIAL_DOCUMENT_TYPES,
    MAX_FINANCIAL_DOCUMENT_FILE_SIZE_BYTES,
    MAX_FINANCIAL_DOCUMENT_FILE_SIZE_MB,
} from "@common/constants/financial-documents";

// Single source of truth — the backend validates against the same constants on
// confirm-upload, so re-exporting (rather than re-declaring) keeps client and
// server in lockstep.
export const AGENT_CHAT_ACCEPTED_MIMES = FINANCIAL_DOCUMENT_TYPES;

export const AGENT_CHAT_MAX_FILE_BYTES = MAX_FINANCIAL_DOCUMENT_FILE_SIZE_BYTES;
export const AGENT_CHAT_MAX_FILE_MB = MAX_FINANCIAL_DOCUMENT_FILE_SIZE_MB;

// Chat-scoped — no equivalent backend constant; this caps how many files a
// single user turn can carry.
export const AGENT_CHAT_MAX_FILES_PER_TURN = 5;
